<template>


    <div class="media" v-if="!isMobile">
        <div class="left-content">
            <label
                style="font-size:24px;color:#301E03;height: 102px;display: flex;justify-content: center;align-items: center;">圖片集與視頻</label>
            <label v-for="(item, index) in aboutList" :key="index"
                :class="['left-item', { leftactive: curItem == index }]" @click=chooseTap(index)>{{ item }}
            </label>
        </div>

        <div class="right-content">
            <!-- 這是圖片 -->
            <div v-if="curItem == 0">
                <div class="detail-top" v-if="curImagesId !== ''">
                    <label class="detail-font" @click="returnLast" style="cursor: pointer;color: #A05200;">圖片集</label>
                    <label class="detail-font"> > </label>
                    <label class="detail-font">{{ curImagesTitle }}</label>
                </div>
                <!-- 相册内容 -->
                <div v-if="curImagesId !== ''" class="media-list">
                    <div v-for="(item, index) in imageInnerList" :key="index" class="media-item-inner">
                        <div class="media-img-layout-inner">
                            <el-image :src="item.img_url" fit='contain' width="100%" height="100%"
                                :preview-src-list="srcList" :z-index="index">
                            </el-image>
                        </div>

                        <span class="media-title-inner">{{ item.name }}</span>
                    </div>
                </div>
                <!-- 正常的相册列表 -->
                <div v-else class="media-list">
                    <div v-for="(item, index) in imageList" :key="index" class="media-item" @click=chooseItem(index)>
                        <div class="media-img-layout">
                            <img class="media-img" :src="item.img_url">
                            <div class="media-count">{{ item.img_count }}张</div>
                        </div>

                        <span class="media-title">{{ item.name }}</span>

                        <label class="media-time">{{ item.guide }}</label>
                    </div>
                </div>
            </div>
            <!-- 這是視頻 -->
            <div v-else>
                <div class="media-list">
                    <div v-for="(item, index) in videoList" :key="index" class="video-item">
                        <div class="video-top">
                            <img class="my-video" :src="item.img_url">
                            <img class="start-btn-img" src="../assets/start_video.png" @click="openVideo(item)" />
                        </div>
                        <span class="video-title">{{ item.name }}</span>

                        <label class="video-time">{{ item.guide }}</label>
                    </div>
                </div>


            </div>

            <el-pagination class="news-bottom-page" background layout="prev, pager, next"
                @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.page"
                :page-size="queryInfo.pagesize" :page-sizes="[1, 2, 5, 10]" :total="totalNum">
            </el-pagination>

        </div>

        <VideoDialog ref="myVideoDialog"></VideoDialog>
    </div>


    <div v-else class="media-mobile">
        <div class="media-title-mobile">
            <label class="media-msg-mobile">圖片集與視頻</label>
        </div>

        <el-menu background-color="#EFE9E0" :default-active="curItem" text-color="#301E03" active-text-color="#A05200"
            class="el-menu-demo" mode="horizontal" @select="chooseTap">
            <el-menu-item v-for="(item, index) in aboutList" :key="index" :index="index">{{ item }}
            </el-menu-item>
        </el-menu>


        <!-- 這是圖片 -->
        <div v-if="curItem == 0">
            <div class="detail-top" v-if="curImagesId !== ''">
                <label class="detail-font" @click="returnLast" style="cursor: pointer;color: #A05200;">圖片集</label>
                <label class="detail-font"> > </label>
                <label class="detail-font">{{ curImagesTitle }}</label>
            </div>
            <!-- 相册内容 -->
            <div v-if="curImagesId !== ''">
                <div class="media-list-inner">
                    <div v-for="(item, index) in imageInnerList" :key="index" class="media-item-inner">
                        <div class="media-img-layout-inner">
                            <el-image :src="item.img_url" fit='contain' width="100%" height="100%"
                                :preview-src-list="srcList" :z-index="index">
                            </el-image>
                        </div>

                        <span class="media-title-inner">{{ item.name }}</span>
                    </div>
                </div>
                <el-pagination class="media-bottom-page-mobile-inner" background layout="prev, pager, next"
                    @size-change="handleSizeChange" @current-change="handleCurrentChange" small
                    :current-page="queryInfo.page" :page-size="queryInfo.pagesize" :page-sizes="[1, 2, 5, 10]"
                    :total="totalNum">
                </el-pagination>
            </div>


            <!-- 正常的相册列表 -->
            <div v-else class="media-list">
                <div v-for="(item, index) of imageList" :key="index" class="media-item" @click=chooseItem(index)>
                    <div class="media-img-layout">
                        <img class="media-img" :src="item.img_url">
                        <div class="media-count">{{ item.img_count }}张</div>
                    </div>

                    <span class="media-title">{{ item.name }}</span>

                    <label class="media-time">{{ item.create_time }}</label>
                </div>

                <el-pagination class="media-bottom-page-mobile" background layout="prev, pager, next"
                    @size-change="handleSizeChange" @current-change="handleCurrentChange" small
                    :current-page="queryInfo.page" :page-size="queryInfo.pagesize" :page-sizes="[1, 2, 5, 10]"
                    :total="totalNum">
                </el-pagination>
            </div>

        </div>
        <!-- 這是视频 -->
        <div v-else class="media-list">
            <div v-for="(item, index) of videoList" :key="index" class="video-item">
                <div class="video-top">
                    <img class="my-video" :src="item.img_url">
                    <img class="start-btn-img" src="../assets/start_video.png" @click="openVideo(item)" />
                </div>
                <span class="video-title">{{ item.name }}</span>

                <label class="video-time">{{ item.create_time }}</label>
            </div>
            <el-pagination class="media-bottom-page-mobile" background layout="prev, pager, next"
                @size-change="handleSizeChange" @current-change="handleCurrentChange" small
                :current-page="queryInfo.page" :page-size="queryInfo.pagesize" :page-sizes="[1, 2, 5, 10]"
                :total="totalNum">
            </el-pagination>
        </div>

        <VideoDialog ref="myVideoDialog"></VideoDialog>
    </div>


</template>

<script>
import VideoDialog from '../components/video_dialog.vue';
export default {
    name: 'Media',
    components: {
        VideoDialog,
    },
    data() {
        return {
            curItem: 0,
            aboutList: ['圖片集', '精彩視頻'],
            curImagesId: "",
            curImagesTitle: "",
            isMobile: false,
            totalNum: 0,
            queryInfo: {
                query: "",
                // 当前页数
                page: 1,
                // 显示一页多少条数据
                pagesize: 9,
            },
            srcList: [
            'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
            'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
            ],
            videoList: [],
            imageList: [],
            imageInnerList: [],
            videoPath: ""
        }
    },

    created() {

        this.isMobile = window.isMobile

        var photoData = this.$route.params.imageData
        if (photoData) {

            console.log('photoData=' + photoData)
            this.curImagesId = photoData.id;
            this.curImagesTitle = photoData.name;

            localStorage.setItem("curItem", 0);
            localStorage.setItem("curImagesId", this.curImagesId);
            localStorage.setItem("curImagesTitle", this.curImagesTitle);
        }



    },
    mounted() {
        console.log("刷新！")
        if(localStorage.getItem("curItem")){
            this.curItem=  localStorage.getItem("curItem")
            this.curImagesId=  localStorage.getItem("curImagesId")
            this.curImagesTitle=  localStorage.getItem("curImagesTitle")
        }else{
            localStorage.setItem("curItem", 0);
            localStorage.setItem("curImagesId","");
            localStorage.setItem("curImagesTitle", "");
        }

        this.fetchData()
    },
    methods: {
        chooseTap(index) {
            this.curImagesId = '';
            this.curItem = index;
            this.imageInnerList=[]

            this.queryInfo={
                query: "",
                // 当前页数
                page: 1,
                // 显示一页多少条数据
                pagesize: 9,
            }
            this.fetchData()


            localStorage.setItem("curItem", this.curItem);
            localStorage.setItem("curImagesId","");
            localStorage.setItem("curImagesTitle", "");

        },
        chooseItem(index) {
            this.curImagesId = this.imageList[index].id + "";
            this.curImagesTitle = this.imageList[index].name

            localStorage.setItem("curImagesId", this.curImagesId);
            localStorage.setItem("curImagesTitle", this.curImagesTitle);
            this.imageInnerList=[]
            this.findInnerImagesById()
        },
        findInnerImagesById() {
            var that = this
            this.$axios.get("img/lists", { params: { cateId: this.curImagesId, page: this.queryInfo.page, limit: this.isMobile?10:this.queryInfo.pagesize } }).then(function (response) {
                that.imageInnerList = response.data.data
                that.totalNum = response.data.count

                window.scrollTo({
                    top: 0,
                });

              that.srcList= that.imageInnerList.map((item)=>{
                   return item.img_url;
                })

            }, function (err) {
                console.log('errerrerrerrerr ' + err);
            });
        },
        returnLast() {
            this.curImagesId = '';
            this.imageInnerList=[]

            localStorage.setItem("curImagesId","");
            localStorage.setItem("curImagesTitle", "");
        },

        fetchData() {
            var that = this;

            if (this.curItem == 1) {
                this.$axios.get("video/lists", { params: { page: this.queryInfo.page, limit: this.queryInfo.pagesize } }).then(function (response) {
                    that.videoList = response.data.data
                    that.totalNum = response.data.count

                    window.scrollTo({
                        top: 0,
                    });

                }, function (err) {
                    console.log('errerrerrerrerr ' + err);
                });
            } else {
                if (this.curImagesId != "") {
                    this.findInnerImagesById()
                    return
                }
                this.$axios.get("img/cate", { params: { page: this.queryInfo.page, limit: this.queryInfo.pagesize } }).then(function (response) {
                    that.imageList = response.data.data
                    that.totalNum = response.data.count

                    window.scrollTo({
                        top: 0,
                    });

                }, function (err) {
                    console.log('errerrerrerrerr ' + err);
                });


            }

        },
        openVideo(item) {
            this.$refs.myVideoDialog.openVideo(item.video_url)
        },
        //每页的数据条数的需求，重新调用方法获取新的数据
        handleSizeChange(val) {
            this.queryInfo.pagesize = val;
            this.fetchData();
        },
        //识别到页数的变化，自动获取新的数据
        handleCurrentChange(val) {
            this.queryInfo.page = val;
            this.fetchData();
        },
    },
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.media {
    justify-content: center;
    display: flex;
    align-items: flex-start;
    padding: 30px 0px 88px 0px;
    width: 100%;
    display: flex;
    box-sizing: border-box;

    .left-content {
        justify-content: space-evenly;
        display: flex;
        flex-direction: column;
        width: 208px;
        height: 220px;
        background-color: #D9C8AD;


        .left-item {
            cursor: pointer;
            font-size: 18px;
            color: #301E03;
            padding-left: 32px;
            height: 54px;
            line-height: 54px;
        }

        .leftactive {
            background-color: #F2E7D5;
            color: #A05200;
        }
    }


    .right-content {
        flex-direction: column;
        align-items: center;
        overflow: hidden;
        width: 831px;
        margin-left: 20px;
        min-height: 740px;

        .detail-top {
            margin-bottom: 20px;
            box-sizing: border-box;
            width: 831px;

            .detail-font {
                font-size: 14px;
                color: #301E03;
            }
        }

        .media-list {
            width: 831px;
            display: flex;
            display: -webkit-flex;
            flex-direction: row;
            flex-wrap: wrap;

            .media-item {
                background-image: url(../assets/photo_border.png);
                background-size: 100% 100%;
                /*按比例缩放*/
                background-repeat: no-repeat;
                margin-right: 13px;
                height: 254px;
                margin-bottom: 20px;
                width: calc((100% - 39px) / 3);
                box-sizing: border-box;
                display: flex;
                flex-direction: column;


                .media-img-layout {
                    box-sizing: border-box;
                    padding: 0 8px;
                    position: relative;
                    margin-top: 18px;
                    overflow: hidden;
                    text-align: center;
                    cursor: pointer;
                    width: 100%;
                    height: 164px;


                    .media-img {
                        border-radius: 8px;
                        height: 100%;
                        width: 100%;
                        object-fit: cover;
                    }

                    .media-count {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 14px;
                        color: #FFFFFF;
                        font-family: Arial, Helvetica, sans-serif;
                        right: 8%;
                        bottom: 10px;
                        position: absolute;
                        width: 57px;
                        height: 24px;
                        background: rgba(0, 0, 0, 0.50);
                        border-radius: 12px;
                    }

                }

                .media-title {
                    margin-left: 12px;
                    font-size: 16px;
                    color: #301E03;
                    margin-top: 12px;
                    cursor: pointer;
                    display: inline-block;
                    white-space: nowrap;
                    width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .media-time {
                    color: #A05200;
                    font-size: 16px;
                    margin-left: 12px;
                    margin-top: 4px;
                }
            }

            .media-item-inner {
                margin-right: 20px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                height: 206px;
                width: calc((100% - 60px) / 3);
                margin-bottom: 20px;


                .media-img-layout-inner {
                    border: 1px solid #D9C8AD;
                    box-shadow: 0 0 1px 0.5px #aaa;
                    border-radius: 8px;
                    box-sizing: border-box;
                    position: relative;
                    overflow: hidden;
                    text-align: center;
                    cursor: pointer;
                    width: 100%;
                    height: 172px;


                    ::v-deep .el-image {
                        width: 100%;
                        height: 100%;
                    }

                }

                .media-title-inner {
                    text-align: center;
                    font-size: 16px;
                    color: #301E03;
                    margin-top: 10px;
                    cursor: pointer;
                    display: inline-block;
                    white-space: nowrap;
                    width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }


            .video-item {
                margin-right: 13px;
                width: 400px;
                height: 283px;
                display: flex;
                flex-direction: column;
                margin-bottom: 20px;

                .video-top {
                    position: relative;
                    height: 225px;
                    width: 400px;

                    .my-video {
                        height: 225px;
                        width: 400px;
                        border-radius: 6px;
                        object-fit: cover;
                    }

                    .start-btn-img {
                        cursor: pointer;
                        border-radius: 50%;
                        box-shadow: 0px 0.5px 0.5px 0.5px #EFE9E0;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        width: 42px;
                        height: 42px;
                        transform: translate(-50%, -50%);
                    }
                }


                .video-title {
                    font-size: 16px;
                    color: #301E03;
                    margin-top: 10px;
                    cursor: pointer;
                    display: inline-block;
                    white-space: nowrap;
                    width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .video-time {
                    color: #A05200;
                    font-size: 16px;
                    margin-top: 4px;
                }

            }
        }

        .news-bottom-page {
            display: flex;
            justify-content: center;
            margin-top: 40px;
        }

        .el-pagination.is-background .el-pager li:not(.disabled).active {
            background-color: #D9C8AD;
            color: #fff;
        }
    }

}

.media-mobile {
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    .el-menu-demo {
        ::v-deep .el-menu-item {
            width: 25%;
            text-align: center;
        }
    }

    .media-title-mobile {
        box-sizing: border-box;
        padding-left: 20px;
        margin-top: 20px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding-bottom: 20px;

        .media-msg-mobile {
            font-size: 22px;
            color: #301E03
        }
    }


    .detail-top {
        padding-left: 20px;
        width: 100vw;
        margin-bottom: 20px;
        margin-top: 20px;
        box-sizing: border-box;


        .detail-font {
            font-size: 14px;
            color: #301E03;
        }
    }

    .media-list {
        box-sizing: border-box;
        padding: 0px 20px;
        width: 100vw;
        margin-top: 20px;
        display: flex;
        display: -webkit-flex;
        flex-direction: column;
        align-items: center;

        .media-item {
            padding: 0px 8px;
            margin-bottom: 30px;
            background-image: url(../assets/photo_border.png);
            background-size: 100% 100%;
            /*按比例缩放*/
            background-repeat: no-repeat;
            width: calc(100vw - 40px);
            box-sizing: border-box;
            display: -webkit-flex;
            display: flex;
            flex-direction: column;

            .media-img-layout {
                position: relative;
                margin-top: 18px;
                overflow: hidden;
                text-align: center;
                cursor: pointer;
                width: calc(100vw - 40px - 16px);
                height: calc((100vw - 40px - 16px)*2/3);


                .media-img {
                    border-radius: 8px;
                    height: 100%;
                    width: 100%;
                    object-fit: cover;
                }

                .media-count {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 14px;
                    color: #FFFFFF;
                    font-family: Arial, Helvetica, sans-serif;
                    right: 10px;
                    bottom: 10px;
                    position: absolute;
                    width: 57px;
                    height: 24px;
                    background: rgba(0, 0, 0, 0.50);
                    border-radius: 12px;
                }

            }

            .media-title {
                margin-left: 4px;
                font-size: 16px;
                color: #301E03;
                margin-top: 12px;
                cursor: pointer;
                display: inline-block;
                white-space: nowrap;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .media-time {
                margin-left: 4px;
                color: #A05200;
                font-size: 16px;
                margin-bottom: 12px;
                margin-top: 4px;
            }
        }

        .video-item {
            margin-bottom: 30px;
            box-sizing: border-box;
            display: -webkit-flex;
            display: flex;
            flex-direction: column;
            width: calc(100vw - 40px);

            // .my-video {
            //     background-color: #000000;
            //     height: calc((100vw - 40px)*9/16);
            //     width: calc(100vw - 40px);
            //     border-radius: 6px;
            // }

            .video-top {
                position: relative;
                height: calc((100vw - 40px)*9/16);
                width: calc(100vw - 40px);

                .my-video {
                    height: calc((100vw - 40px)*9/16);
                    width: calc(100vw - 40px);
                    border-radius: 6px;
                    object-fit: cover;
                }

                .start-btn-img {
                    cursor: pointer;
                    border-radius: 50%;
                    box-shadow: 0px 0.5px 0.5px 0.5px #EFE9E0;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    width: 38px;
                    height: 38px;
                    transform: translate(-50%, -50%);
                }
            }

            .video-title {
                font-size: 16px;
                color: #301E03;
                margin-top: 10px;
                cursor: pointer;
                display: inline-block;
                white-space: nowrap;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .video-time {
                color: #A05200;
                font-size: 16px;
                margin-top: 4px;
            }
        }

        .media-bottom-page-mobile {
            margin-top: 10px;
            margin-bottom: 80px;
        }

        .el-pagination.is-background .el-pager li:not(.disabled).active {
            background-color: #D9C8AD;
            color: #fff;
        }
    }

    .media-list-inner {
        box-sizing: border-box;
        padding: 0px 20px;
        width: 100vw;
        margin-top: 20px;
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        flex-wrap: wrap;

        .media-item-inner {
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;
            width: calc((100vw - 40px)/2 - 5px);
            margin-bottom: 20px;


            .media-img-layout-inner {
                border: 1px solid #D9C8AD;
                border-radius: 8px;
                box-sizing: border-box;
                position: relative;
                overflow: hidden;
                text-align: center;
                cursor: pointer;
                width: 100%;
                height: calc(((100vw - 40px) / 2 - 5px) * 2 / 3);


                ::v-deep .el-image {
                    width: 100%;
                    height: 100%;
                }
            }

            .media-title-inner {
                text-align: center;
                font-size: 16px;
                color: #301E03;
                margin-top: 10px;
                cursor: pointer;
                display: inline-block;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        .media-item-inner:nth-child(odd) {
            margin-right: 10px;
        }

    }

    .media-bottom-page-mobile-inner {
        text-align: center;
        width: 100vw;
        margin-top: 10px;
        margin-bottom: 80px;

        .el-pagination.is-background .el-pager li:not(.disabled).active {
            background-color: #D9C8AD;
            color: #fff;
        }
    }


}
</style>
